<template>
    <div class="vx-col w-full">
        <div class="image-upload-wrap">
            <input class="file-upload-input" type='file' ref="fileInput" @change="readFile" />
            <div class="drag-text">
                <p class="font-bold mb-3 text-xl">{{title}}</p>
                <p>{{desc}}</p>
            </div>
        </div>
    </div>
</template>

<script>

import Crypto           from '@/helper/crypto'
import ErrorHandler     from '@/helper/error_handler'
import Global           from '@/helper/global'

export default {
    name: 'input-file',
    props: ['title', 'desc'],
    props: {
        title: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
    },
    data () {
        return {

        }
    },
    methods: {
        readFile(e){
          const files = e.target.files
          if(files){
            this.$emit('onUpload', files[0]);
          } else {
            this.$vs.notify({
                color:'danger',
                title:'VIAMOVE SYSTEM',
                text: 'File not found!'
            })
          }

          e.target.value = null
        }
    }
}
</script>

